<template>
  <div>
    <dl class="change-payment-mode">
      <dt class="change-payment-mode__title">Оплачено (сумма)</dt>
      <dd class="change-payment-mode__value">{{ payment.totalPaid }}</dd>
    </dl>
    <form
      class="form-change-payment-mode"
      v-on:submit.prevent="onSubmit"
    >
      <div
        class="form-change-payment-mode__modes"
        v-for="paymentMode in paymentModes"
        v-bind:key="paymentMode.mode"
      >
        <template v-if="paymentMode.mode === $options.paymentModeAdvance">
          <span>
            С аванса (<the-rub
              v-bind:kop="availableAdvanceKop"
              show-kop="hide"
            />)
          </span>
          <price-input-rub
            v-model="paymentMode.amount"
            v-bind:max="availableAdvanceKop"
            v-bind:disabled="paymentMode.disabled"
          />
        </template>
        <template v-else>
          <span>{{ paymentMode.title }}</span>
          <price-input-rub
            v-model="paymentMode.amount"
            v-bind:disabled="paymentMode.disabled"
          />
        </template>
      </div>
      <button
        class="form-change-payment-mode__cancel"
        type="button"
        v-on:click="onCancel"
      >Отмена</button>
      <button
        class="form-change-payment-mode__submit"
        type="submit"
        v-bind:disabled="isSubmitButtonDisabled"
      >Ок</button>
    </form>
  </div>
</template>

<script>
import PriceInputRub from '@/components/PriceInputRub.vue';
import TheRub from '@/components/TheRub.vue';
import { ChangeInvoicePaymentRequest } from '@/storage/gateways/InvoiceGateway';

const NAME_EVENT_CANCEL = 'cancel';
const NAME_EVENT_SUBMIT = 'submit';
const PAYMENT_MODE_ADVANCE = 'advance';

/**
 * @description Компонент формы изменения способа оплаты.
 * @type {Vue}
 */
export default {
  paymentModeAdvance: PAYMENT_MODE_ADVANCE,
  components: { PriceInputRub, TheRub },
  computed: {
    availableAdvanceKop() {
      const paidAdvance = this.payment.paymentModes.reduce(
        (amount, paymentMode) => (paymentMode.mode === PAYMENT_MODE_ADVANCE
          ? amount + paymentMode.amount
          : amount),
        0,
      );
      return (this.payment.availableAdvance + paidAdvance) * 100;
    },
    paymentAmount() {
      return this
        .paymentModes
        .reduce((amount, paymentMode) => amount + paymentMode.amount, 0);
    },
    isSubmitButtonDisabled() {
      return this.isAwaitRequest || this.paymentAmount !== this.payment.totalPaid * 100;
    },
  },
  data() {
    return {
      paymentModes: this
        .payment
        .paymentModes
        .map((paymentMode) => ({
          amount: paymentMode.amount * 100,
          disabled: paymentMode.actions.indexOf('change') === -1,
          mode: paymentMode.mode,
          title: paymentMode.title,
        })),
    };
  },
  methods: {
    makeRequest() {
      const paymentModes = this
        .paymentModes
        .filter(({ disabled }) => disabled !== true)
        .map(({ amount, mode }) => ({ amount, mode }));
      return new ChangeInvoicePaymentRequest(
        this.payment.id,
        paymentModes,
      );
    },
    onCancel() {
      this.$emit(NAME_EVENT_CANCEL);
    },
    onSubmit() {
      const request = this.makeRequest();
      this.$emit(NAME_EVENT_SUBMIT, request);
    },
  },
  props: {
    isAwaitRequest: { default: false, type: Boolean },
    payment: { required: true, type: Object },
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.change-payment-mode {
  & &__title::after {
    content: ":";
  }
  & &__title,
  & &__value {
    color: var(--reading-color);
    display: inline;
  }
  & &__title + &__value {
    margin-left: 3rem;
  }
}

.form-change-payment-mode {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  margin-top: 1.5rem;
  & &__modes {
    color: var(--reading-color);
    grid-column: 1 / 4;
  }
  & &__submit {
    @include buttons.btn-blue(100%, 3rem, 1rem);
    min-width: 100px;
  }
  & &__submit:disabled {
    background-color: var(--unfocus-color);
    border: 1px solid var(--unfocus-color);
    color: var(--primary-background-color);
  }
  & &__cancel {
    @include buttons.btn-transparent(100%, 3rem, 1rem);
    min-width: 100px;
  }
}
</style>
